import { BaseService } from "../baseService";
import { PalletLocationAPIService } from "./palletLocationAPIService";
import { PalletLocationRecord } from "src/types/database";

class PalletLocationService extends BaseService<PalletLocationAPIService> {
  async getPalletLocations(): Promise<PalletLocationRecord[]> {
    const { locations } = await this.apiService.getPalletLocations();
    return locations;
  }
}

export { PalletLocationService };
